export let accMessageBarDismissLink = "hOFfyb";
export default {accMessageBarDismissLink};